import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

import Button from "../../../../components/Form/Button";

export const LoginForm = styled("form")(() => ({
  display: "flex",
  maxWidth: "442px",
  width: "100%",
  padding: "40px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",
  borderRadius: "4px",
  borderTop: `4px solid ${colors.brandBlue500}`,
  background: "#FFF",
  boxShadow: "0px 1px 3px 0px rgba(71, 84, 103, 0.30), 0px 4px 8px 3px rgba(71, 84, 103, 0.15)",
  "@media screen and (max-width: 442px)": {
    height: "100%",
    justifyContent: "center",
  },
}));

export const LogoImage = styled("img")(() => ({
  maxHeight: 80,
  maxWidth: 352,
  "@media screen and (max-width: 442px)": {
    maxWidth: 280,
  },
}));

export const LoginInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "12px",
  width: "100%",
}));

export const LoginTitle = styled("span")(() => ({
  color: "#475467",
  textAlign: "center",
  font: "500 32px Manrope",
  lineHeight: "40px",
}));

export const LoginSubtitle = styled("span")(() => ({
  color: "#475467",
  textAlign: "center",
  font: "400 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const LoginFormWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  width: "100%",
}));

export const ShowPasswordIcon = styled(AiOutlineEye)(() => ({
  cursor: "pointer",
}));

export const HidePasswordIcon = styled(AiOutlineEyeInvisible)(() => ({
  cursor: "pointer",
}));

export const ResetPasswordButton = styled(Button)(() => ({
  backgroundColor: `${colors.brandBlue500} !important`,
  color: "#FFFFFF !important",
}));

const styles = makeStyles(() => ({
  label: {
    color: colors.brandBlue500,
  },
}));

export default styles;
